import React from 'react';

import DOMPurify from 'dompurify';

import { renderMarkupWithMath } from 'utils/latexRenderer';

import styles from './styles.module.scss';

const PreviewField = ({ initialValue = '' }) => {
  const text =
    typeof initialValue === 'object' && initialValue?.ops
      ? initialValue.ops.map((op) => op.insert).join('')
      : initialValue || '';

  const paragraphs = text.split(/\n+/).filter(Boolean);

  return (
    <div className={styles.previewContainer}>
      {paragraphs.map((line, i) => (
        <div
          key={i}
          className={styles.paragraph}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(renderMarkupWithMath({ text: line }))
          }}
        />
      ))}
    </div>
  );
};

export default PreviewField;
